module.exports = __webpack_public_path__ + "static/media/Vadiraj_Joshi.93590bda.jpg";